import React from 'react';
import { AgentCardProps } from '../types';
import Typography from '../../../basic/Typography';
import styles from '../Cast.module.css';

export const AgentCard: React.FC<AgentCardProps> = ({ agent, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(agent);
    }
  };

  return (
    <div className={styles['agent-card']} onClick={handleClick}>
      <div className={styles['agent-card-image']}>
        {agent.headshot_url ? (
          <img
            src={`/cast/${agent.headshot_url}`}
            alt={`${agent.name} headshot`}
            className={styles['agent-headshot']}
          />
        ) : (
          <div className={styles['agent-placeholder']}>
            <span className={styles['placeholder-icon']}>👤</span>
          </div>
        )}
      </div>

      <div className={styles['agent-card-content']}>
        <Typography variant="h3" className={styles['agent-name']} gutterBottom={true}>
          {agent.name}
        </Typography>
        {agent.bio && (
          <Typography variant="body2" className={styles['agent-bio']} gutterBottom={true}>
            {agent.bio.length > 100
              ? `${agent.bio.substring(0, 100)}...`
              : agent.bio
            }
          </Typography>
        )}

        <div className={styles['agent-assets']}>
          {agent.char_sheets && agent.char_sheets.length > 0 && (
            <span className={styles['asset-badge']}>📄 Character Sheets</span>
          )}
          {agent.auditions && agent.auditions.length > 0 && (
            <span className={styles['asset-badge']}>🎬 Auditions</span>
          )}
          {agent.control_voices && agent.control_voices.length > 0 && (
            <span className={styles['asset-badge']}>🎤 Voice Samples</span>
          )}
        </div>
      </div>
    </div>
  );
};